import { Grid, useMediaQuery } from "@material-ui/core";
import React from "react";
import { createUseStyles } from "react-jss";
import HeaderLogo from "./HeaderLogo";

const useStyles = createUseStyles({
  container: {
    flexDirection: "column",
    alignItems: "center",
  },
});

const LoginHeader = () => {
  const classes = useStyles();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  return (
    <Grid
      container
      className={classes.container}
      style={{
        justifyContent: matchesMediaQuery ? "flex-end" : "space-around",
        height: matchesMediaQuery ? 223 : 183,
      }}
    >
      <Grid item md={1} sm={6} style={{ width: 100 }}>
        <HeaderLogo />
      </Grid>
    </Grid>
  );
};

export default React.memo(LoginHeader);
